<template>
  <ul v-bind:style="value.itemsStyle" v-bind:class="value.itemsClass">
    <li v-for="(item, index) in value.items" v-bind:key="index" v-bind:style="item.itemStyle"
        v-bind:class="item.itemClass">
      <template v-if="item.href">
        <template v-if="item.items">
          <a v-bind:href="item.href" v-on:click.prevent="openIndex == index ? openIndex = null : openIndex = index"
             v-bind:style="item.style"
             class="d-flex align-items-center"
             v-bind:class="item.styleClass">
            <i v-if="item.icon" class="flex-grow-0" v-bind:class="item.icon"></i>
            <span class="flex-grow-1">{{ item.text }}</span>
            <i class="flex-grow-0 fal"
               v-bind:class="{'fa-chevron-right': openIndex != index, 'fa-chevron-down': openIndex == index}"></i>
          </a>
          <transition name="new-menu-slide">
            <recursive-menu v-if="openIndex == index" v-bind:value="item"/>
          </transition>
        </template>
        <a v-else=""
           v-bind:href="item.href"
           v-bind:style="item.style"
           class="d-flex align-items-center"
           v-bind:class="item.styleClass">
          <i v-if="item.icon" class="flex-grow-0" v-bind:class="item.icon"></i>
          <span class="flex-grow-1">{{ item.text }}</span>
        </a>
      </template>
      <template v-else="">
        <span v-bind:style="item.style" v-bind:class="item.styleClass">
            <i v-if="item.icon" v-bind:class="item.icon"></i>
            <img v-if="item.portrait" v-bind:src="item.portrait"/>
            {{ item.text }}
            <a v-if="item.phone" v-bind:href="'tel:' + item.phone" class="link-dark"><template
                v-if="item.phonePrefix">{{ item.phonePrefix }}</template>{{ item.phone }}</a>
            <a v-if="item.email" v-bind:href="'mailto:' + item.email" class="link-dark">{{ item.email }}</a>
        </span>
        <recursive-menu v-if="item.items" v-bind:value="item"/>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: "recursive-menu",
  props: ["value"],
  data: function () {
    return {
      openIndex: null
    }
  }
}
</script>
